export default __webpack_public_path__ + "static/media/Group 4069.3c229793.svg";